<template>
  <div class="rubric">
    <h3 class="is-size-5">{{ name }} — <b>{{ value }}</b></h3>
    <Slider
      @changedValue="changedScore"
    />
    <textarea
      v-model="comment"
      cols="30"
      rows="2"
      class="textarea"
      placeholder="Leave an observation or praise."
      @change="changedComment"
    />
  </div>
</template>

<script>
import Slider from '@/components/inputs/Slider'

export default {
  name: 'GradingRubric',
  components: {
    Slider
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: 5.5,
      comment: ''
    }
  },
  methods: {
    changedScore (value) {
      this.value = value
      this.$emit('changedScore', {
        value: value,
        slug: this.slug
      })
    },
    changedComment (value) {
      this.$emit('changedComment', {
        value: this.comment,
        slug: this.slug
      })
    }
  }
}
</script>

<style lang="scss">
  .rubric{
    margin-bottom: 25px;

    textarea {
      margin-top: 15px;
      resize: none;
    }
  }
</style>
